import {
  FaBan,
  FaBuilding,
  FaChartBar,
  FaClock,
  FaCog,
  FaFileContract,
  FaFileInvoiceDollar,
  FaMoneyBill,
  FaPhone,
  FaRobot,
  FaShieldAlt,
  FaSms,
  FaTags,
  FaTerminal,
  FaUserPlus,
  FaUsers,
} from "react-icons/fa";
import type { IconType } from "react-icons";

export interface PlatformAdminNavItem {
  path: string;
  label: string;
  icon: IconType;
}

export const platformAdminNavItems: PlatformAdminNavItem[] = [
  { path: "/platform-admin/logs", label: "Live Logs", icon: FaTerminal },
  { path: "/platform-admin/organisations", label: "Organisations", icon: FaBuilding },
  { path: "/platform-admin/access-requests", label: "Access Requests", icon: FaUserPlus },
  { path: "/platform-admin/a2p-registrations", label: "SMS Registrations", icon: FaSms },
  { path: "/platform-admin/tax-exemptions", label: "Tax Exemptions", icon: FaFileContract },
  { path: "/platform-admin/email-blocklist", label: "Email Blocklist", icon: FaBan },
  { path: "/platform-admin/calling-rules", label: "Calling Rules", icon: FaClock },
  { path: "/platform-admin/fraud-signals", label: "Risk Signals", icon: FaShieldAlt },
  { path: "/platform-admin/charges", label: "Charges", icon: FaMoneyBill },
  { path: "/platform-admin/activity", label: "Activity", icon: FaFileInvoiceDollar },
  { path: "/platform-admin/users", label: "Users", icon: FaUsers },
  { path: "/platform-admin/phone-numbers", label: "Phone Numbers", icon: FaPhone },
  { path: "/platform-admin/pricing", label: "Pricing", icon: FaTags },
  { path: "/platform-admin/ai-agents", label: "AI Agents", icon: FaRobot },
  { path: "/platform-admin/analytics", label: "Analytics", icon: FaChartBar },
  { path: "/platform-admin/settings", label: "Settings", icon: FaCog },
];
